"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType[TokenType["LeftParen"] = 1] = "LeftParen";
    TokenType[TokenType["RightParen"] = 2] = "RightParen";
    TokenType[TokenType["Comma"] = 3] = "Comma";
    TokenType[TokenType["Period"] = 4] = "Period";
    TokenType[TokenType["Identifier"] = 20] = "Identifier";
    TokenType[TokenType["String"] = 21] = "String";
    TokenType[TokenType["Number"] = 22] = "Number";
    TokenType[TokenType["True"] = 23] = "True";
    TokenType[TokenType["False"] = 24] = "False";
    TokenType[TokenType["Null"] = 25] = "Null";
    TokenType[TokenType["Whitespace"] = 50] = "Whitespace";
    TokenType[TokenType["Unknown"] = 51] = "Unknown";
    TokenType[TokenType["EOF"] = 99] = "EOF";
})(TokenType || (exports.TokenType = TokenType = {}));
//# sourceMappingURL=token_type.js.map